import { render, staticRenderFns } from "./calculator-icon.vue?vue&type=template&id=54dea3fe&"
import script from "./calculator-icon.vue?vue&type=script&lang=js&"
export * from "./calculator-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports